export const CONFIG = {
  API_URL: 'https://api.cloudkitchens.com',
};
